<template>
  <transition name="toast">
    <div v-if="show" class="custom-toast" :class="type">
      <div class="toast-content">
        <i v-if="type === 'success'" class="fas fa-check-circle"></i>
        <i v-else-if="type === 'loading'" class="fas fa-spinner fa-spin"></i>
        <i v-else-if="type === 'error'" class="fas fa-exclamation-circle"></i>
        <span>{{ message }}</span>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'Toast',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    message: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'success'
    }
  }
}
</script>

<style>
.custom-toast {
  position: fixed !important;
  top: 20px !important;
  right: 20px !important;
  padding: 12px 24px !important;
  border-radius: 4px !important;
  background: white !important;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15) !important;
  z-index: 9999 !important;
  display: flex !important;
  align-items: center !important;
  min-width: 200px !important;
  transform: translateX(0) !important;
  opacity: 1 !important;
}

.toast-content {
  display: flex !important;
  align-items: center !important;
  gap: 8px !important;
  color: white !important;
  font-size: 14px !important;
}

.custom-toast.success {
  background: #F99393 !important;
}

.custom-toast.loading {
  background: #333 !important;
}

.custom-toast.error {
  background: #FF0000 !important;
}

.toast-enter-active,
.toast-leave-active {
  transition: all 0.3s ease !important;
}

.toast-enter-from {
  opacity: 0 !important;
  transform: translateX(100%) !important;
}

.toast-enter-to {
  opacity: 1 !important;
  transform: translateX(0) !important;
}

.toast-leave-from {
  opacity: 1 !important;
  transform: translateX(0) !important;
}

.toast-leave-to {
  opacity: 0 !important;
  transform: translateX(100%) !important;
}
</style> 